export namespace Offset {
  export function getTop($element: HTMLElement | Element) {
    let $rect = ($element as HTMLElement).getBoundingClientRect();
    let $scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return $rect.top + $scrollTop;
  }
  export function getRright($element: HTMLElement | Element) {
    let $left = Offset.getLeft($element);
    return $left + ($element as HTMLElement).offsetWidth;
  }

  export function getBottom($element: HTMLElement | Element) {
    let $top = Offset.getTop($element);
    return $top + ($element as HTMLElement).offsetHeight;
  }

  export function getLeft($element: HTMLElement | Element) {
    let $rect = ($element as HTMLElement).getBoundingClientRect();
    let $scrollTop = window.pageXOffset || document.documentElement.scrollLeft;
    return $rect.left + $scrollTop;
  }
}